import React from 'react';
import { observer } from '../../../shared/observer';
import { router } from '../../../shared/hashRouter';

class OrderSuccessView extends React.Component {
  render() {
    const msg = (this.props.params && this.props.params.message) || 'Спасибо за заказ!';
    return (
      <div className="ng-cart-empty">
        <h1>{msg}</h1>
        <p>Мы свяжемся с вами для подтверждения деталей доставки.</p>
        <a className="btn" href="/catalog" onClick={() => router.go('')}>В каталог</a>
      </div>
    );
  }
}

export const OrderSuccess = observer(OrderSuccessView, ['orderStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/Checkout/OrderSuccess.jsx